import React from 'react';

function SvgCard(props: any, ref: any) {
  const { svgCardRef, refMarker, baseScale, qrcodePosition, handleMouseDown, handleTouch, getRatio, style = {} } = props

  return (
    <svg ref={ref} width='100%' viewBox={`0 0 ${baseScale} ${baseScale / getRatio()}`}
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onMouseDown={(e) => handleMouseDown(e, svgCardRef)} onTouchStart={(e) => handleTouch(e, svgCardRef)}
    >
      {/* Background rectangle - always shows the background color as fallback */}
      <rect 
        id='backgroundRect' 
        width={baseScale} 
        height={baseScale / getRatio()} 
        fill={refMarker?.background || '#FFFFFF'} 
      />
      {/* Background image - shows on top of background rect if available */}
      <image id='background' width={baseScale} height={ baseScale / getRatio() } xlinkHref={refMarker?.imageUrl} />
      {refMarker?.qr?.visible && (
        <image
          id='qrcode'
          x={qrcodePosition.x}
          y={qrcodePosition.y}
          width={baseScale * refMarker?.qr?.scale}
          height={baseScale * refMarker?.qr?.scale}
          xlinkHref={refMarker?.qr?.image}
        />
      )}

      <defs>
        <linearGradient
          id='paint1_linear_529_970'
          x1='241.101'
          y1='43.1313'
          x2='409.793'
          y2='43.1313'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EDEDED' />
          <stop offset='1' stopColor='#FFF' />
        </linearGradient>
        <clipPath id='circleClip1'>
          <circle cx='51' cy='249' r='21' />
        </clipPath>
        <linearGradient
          id='paint2_linear_529_970'
          x1='230.306'
          y1='83.458'
          x2='369.196'
          y2='83.458'
          gradientUnits='userSpaceOnUse'
        >
          <stop  stopColor='#EDEDED' />
          <stop offset='1'  stopColor='#FFF' />
        </linearGradient>
        <clipPath id='circleClip2'>
          <circle cx='107' cy='249' r='21' />
        </clipPath>
        <linearGradient
          id='paint3_linear_529_970'
          x1='222.771'
          y1='123.785'
          x2='340.855'
          y2='123.785'
          gradientUnits='userSpaceOnUse'
        >
          <stop  stopColor='#EDEDED' />
          <stop offset='1'  stopColor='#FFF' />
        </linearGradient>
        <clipPath id='circleClip3'>
          <circle cx='163' cy='249' r='21' />
        </clipPath>

        <linearGradient
          id='paint4_linear_529_970'
          x1='352.758'
          y1='249.212'
          x2='379.697'
          y2='249.212'
          gradientUnits='userSpaceOnUse'
        >
          <stop  stopColor='#EDEDED' />
          <stop offset='1'  stopColor='#F1F2F3' />
        </linearGradient>
        <clipPath id='circleClip4'>
          <circle cx='364' cy='249' r='21' />
        </clipPath>
        <linearGradient
          id='paint5_linear_529_970'
          x1='408.758'
          y1='249.212'
          x2='435.697'
          y2='249.212'
          gradientUnits='userSpaceOnUse'
        >
          <stop  stopColor='#EDEDED' />
          <stop offset='1'  stopColor='#F1F2F3' />
        </linearGradient>
        <clipPath id='circleClip5'>
          <circle cx='420' cy='249' r='21' />
        </clipPath>
        <linearGradient
          id='paint6_linear_529_970'
          x1='464.759'
          y1='249.212'
          x2='491.698'
          y2='249.212'
          gradientUnits='userSpaceOnUse'
        >
          <stop  stopColor='#EDEDED' />
          <stop offset='1'  stopColor='#F1F2F3' />
        </linearGradient>
        <clipPath id='circleClip6'>
          <circle cx='476' cy='249' r='21' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default React.forwardRef(SvgCard)
